import type { CSSProperties, ReactNode } from "react";
import { useEffect, useState } from "react";

interface FadeInDownProps {
  children: ReactNode;
  enabled?: boolean;
}

const fadeInDownKeyframes = `
  @keyframes fadeInDownLocal {
    0% {
      opacity: 0;
      transform: translateY(-100px);
    }
    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

export const FadeInDown = ({ children, enabled = false }: FadeInDownProps) => {
  const [isAnimated, setIsAnimated] = useState(false);
  const [isAnimationDone, setIsAnimationDone] = useState(false);

  useEffect(() => {
    if (enabled) setIsAnimated(true);
  }, [enabled]);

  let style: CSSProperties = {};
  if (enabled && !isAnimationDone) {
    style = isAnimated
      ? { animation: "fadeInDownLocal 0.6s ease-out forwards" }
      : { opacity: 0 };
  }

  const handleAnimationEnd = () => setIsAnimationDone(true);

  return (
    <div style={style} onAnimationEnd={handleAnimationEnd}>
      {enabled && !isAnimationDone && <style>{fadeInDownKeyframes}</style>}
      {children}
    </div>
  );
};
